module.exports = __webpack_public_path__ + "static/media/short-brand-logo.2a1a86d9.svg";